import React from "react";
import { motion } from "framer-motion";

export default function Intro() {
  return (
    <>
      <section className="hero">
        <div className="hero__bg">
          <img
            src={process.env.PUBLIC_URL + "/images/deal/hero-new.jpg"}
            alt="hero"
          />
        </div>

        <div className="auto__container hero">
          <div className="hero__inner">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <div data-aos="fade-up" data-aos-delay={400}>
                    <motion.div
                      animate={{
                        scale: [0, 1.1, 1],
                        opacity: [0, 1],
                      }}
                    >
                      <div className="hero-container">
                        <div className="hero-backing-container">
                          <div className="hero-logos">
                            <div className="lm-logo">
                              <img
                                className="img-fluid"
                                src={
                                  process.env.PUBLIC_URL +
                                  "/images/deal/lm-white.png"
                                }
                                alt="Landmark Ventures"
                              />
                            </div>
                          </div>

                          <h1>
                            <span className="league-spartan-font bold">
                              RSA<span className="teal-col">.</span>
                            </span>
                          </h1>

                          <div className="title-smaller league-spartan-font bold">
                            Landmark Ventures | San Francisco
                          </div>

                          <motion.div
                            initial={{ opacity: 0, x: 20, y: 0 }}
                            animate={{ opacity: 1, y: 0, x: 0 }}
                            transition={{ duration: 0.9, ease: "easeOut" }}
                          >
                            <div>
                              <div className="options-list">
                                <div className="option-heading-text">
                                  <p>
                                    Landmark Ventures is hosting a small set of{" "}
                                    <b>invite-only, complimentary</b>{" "}
                                    experiences for leaders attending{" "}
                                    <b>RSA Conference</b> in San Francisco — designed
                                    for high-signal connection away from the noise
                                    of the show floor.
                                  </p>

                                    <div className="hero-experiences">
                                    <div className="hero-experiences-label">
                                      Available during RSA Week
                                    </div>

                                    <ul className="hero-experiences-list">
                                      <li>
                                        <a href="#option-fcc4f3db">Meet our portfolio companies</a>
                                      </li>
                                      <li>
                                        <a href="#option-862f3971">VIP CISO Welcome Lunch</a>
                                      </li>
                                      <li>
                                        <a href="#option-4748672c">VIP Cocktail Party</a>
                                      </li>
                                      <li>
                                        <a href="#option-4d0bf3e1">Global-Israel Innovation Summit</a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </motion.div>
                        </div>
  
                        <div data-aos="fade-up" data-aos-delay={800}>
                          <div className="hero-btns">
                            <div className="hero-btn">
                              {/* Optional CTA if you want it visible:
                              <a
                                href="#apply"
                                type="button"
                                className="pink-btn no-grad simple"
                              >
                                REQUEST AN INVITATION
                              </a>
                              */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </motion.div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
